import $ from 'jquery';
import Cookies from 'js-cookie';

//constants
const SITE_NAME = 'My Calling';
const GENERIC_ERROR = 'Oops, something went wrong.';

//global object
var app = app || {};

//helper functions
var debug = console.log;
debug.notice = (msg) => console.log('%c' + msg, 'color: #110D66');
debug.success = (msg) => console.log('%c' + msg, 'color: #0B8B11');
debug.warning = (msg) => console.log('%c' + msg, 'color: #C67000');
debug.alert = (msg) => console.log('%c' + msg, 'color: #C50000');

app.get = function (object, path = false, defaultValue = undefined) {
    if (path) {
        let args = path.split('.');
        for (var i = 0; i < args.length; i++) {
            if (!object || !object.hasOwnProperty(args[i])) {
                return defaultValue;
            }
            object = object[args[i]];
        }
    }
    return object || defaultValue;
}

app.getParam = function (varName, fallbackValue = undefined) {
    let pageUrl = window.location.search.substring(1);
    let urlVars = pageUrl.split('&');
    let arrayValue = [];
    for (let i = 0; i < urlVars.length; i++) {
        let varParam = urlVars[i].split('=');
        if (varParam[0] === varName) {
            return varParam[1];
        } else if (varParam[0] === varName + '[]') {
            arrayValue.push(varParam[1]);
        }
    }
    return arrayValue.length ? arrayValue : fallbackValue;
}

app.showLoader = function (message = 'Please wait') {
    $('body')
        .prepend(`
		<div class="reveal-overlay" style="display: block;" data-ajax-loader>
			<div class="ajax-loader-content">
				<div class="row">
					<div class="small-centered small-12 medium-8 columns">
						<i class="fa fa-refresh fa-spin fa-3x fa-fw"></i>
						<p>${message}</p>
					</div>
				</div>
			</div>
		</div>
	`);
}

app.hideLoader = function () {
    $('body')
        .find('[data-ajax-loader]')
        .remove();
}

app.showAlert = function (message = GENERIC_ERROR) {
    let $modal = $(`
		<div class="reveal" data-reveal data-component="alertModal">
			<p>${message}</p>
			<button class="close-button" data-close aria-label="Close modal" type="button">
				<span aria-hidden="true">×</span>
			</button>
		</div>
	`);
    let modal = new Foundation.Reveal($modal, {});
    $modal.foundation('open');
}

app.showFlash = function (message = GENERIC_ERROR, type = 'warning') {
    let $flash = $(`
        <div id="flash-message-container"  data-component="flashMessages" onclick="this.classList.add('hide')">
            <div class="${type} callout block"><div class="message">${message} <i class="fas fa-times pointer"></i></div></div>
        </div>
    `);
    $('body').append($flash);
}

app.ajax = function (url, data = null, showLoader = true) {

    let type = data ? 'post' : 'get';
    return $.ajax({
        url: url,
        data: data,
        type: type,
        timeout: 45000,
        beforeSend: xhr => {
            if (showLoader) app.showLoader();

            let token = Cookies.get('csrfToken');
            if (type == 'post' && token) {
                xhr.setRequestHeader('X-CSRF-Token', token);
            }
        },
        complete: () => {
            if (showLoader) {
                app.hideLoader();
            }
        }
    });
}

app.post = function ($form, showLoader = true) {
    //console.log($form.attr('action'));
    //console.log($form.find(':input').serialize());
    return app.ajax($form.attr('action'), $form.find(':input').serialize(), showLoader);
}

app.getMinBreakpoint = function (size) {
    let basePixelSize = 16;
    let mediaQueryString = Foundation.MediaQuery.get(size);
    let emValue = mediaQueryString.replace('only screen and (min-width: ', '').replace('em)', '');
    let pixelValue = emValue * basePixelSize;
    return pixelValue;
}

app.scrollTo = function (element) {
    let page = $("html, body");

    page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
        page.stop();
        stopSrollBinding();
    });

    page.animate({
        'scrollTop': $(element).offset().top
    }, 750, function () {
        stopSrollBinding();
    });

    function stopSrollBinding() {
        page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
    }
}

//extend jQuery with setClass and getClass functions
app.attachToJquery = function ($) {

    $.fn.setClass = function () {
        this.each(function () {
            if (jQuery(this).data('ComponentClass') === undefined && jQuery(this).data('component') !== undefined) {
                let className = jQuery(this).data('component').charAt(0).toUpperCase() + jQuery(this).data('component').slice(1);
                let ComponentClass = app[className];
                if (!ComponentClass) {
                    debug.warning('app.' + className + ' is not a class!');
                    jQuery(this).data('ComponentClass', false);
                } else {
                    jQuery(this).data('ComponentClass', new ComponentClass(jQuery(this)));
                    //debug.success('app.' + className + ' component LOADED!');
                }
            }
        });
        return this;
    };

    $.fn.getClass = function () {
        return this.data('ComponentClass');
    };

    $.fn.findComponent = function (selector) {
        let componentNames = selector.split(' ');
        let parent = this && this !== window ? this : document;
        let componentSelector = '[data-component="' + componentNames.join('"] [data-component="') + '"]';
        return jQuery(parent).find(componentSelector).setClass();
    }

    $.fn.initialize = function () {

        //load our foundation framework
        //$(this).foundation();

        //instantiate classes for each component that's on the page at the time of page load
        $(this).find('[data-component]').setClass().trigger('load');
        if ($(this).data('component')) {
            $(this).setClass().trigger('load');
        }
    }

    return $;
};

app.attachToJquery(jQuery);

//usage:
//$$('main').getClass() will get the app.Main class attached to [data-component="main"]
//$$('main').remove() will remove [data-component="main"] from the dom
app.findOrCreate = jQuery.fn.findComponent;

//Parent component class which ALL components should extend
app.Component = class {
    constructor($this) {
        this.$el = $this;
        this.el = this.$el.get(0);

        if (typeof this.onLoad === 'function') {
            $this.on('load', () => this.onLoad($this));
        }

        if (typeof this.onReady === 'function') {
            $(() => this.onReady($this));
        }
    }
};

module.exports = app;